import React from "react";
import "./Sobre.css";
import fotoYvinna from "../assets/Yvinna-quem-sou.jpg";

const Sobre = () => {
  return (
    <section id="sobre" className="sobre-section">
      <div className="container">
        <div className="sobre-content">
          <div className="sobre-image">
            <img src={fotoYvinna} alt="Retrato de Yvinna Patrícia" />
          </div>
          <div className="sobre-text">
            <h2>Prazer, Yvinna Patrícia</h2>
            <div className="divider-left"></div>
            <p>
              Minha jornada no mundo da moda e do estilo começou com uma busca
              pessoal pela autoconfiança. Descobri que a imagem que projetamos é
              uma ferramenta poderosa de comunicação, capaz de abrir portas e
              fortalecer quem somos por dentro.
            </p>
            <p>
              Hoje, meu propósito é claro: ajudar você a construir uma imagem
              pessoal autêntica e forte, que reflita sua essência e seus
              objetivos. Acredito que o estilo é uma forma de arte pessoal, e
              estou aqui para ser sua guia nesse processo de descoberta.
            </p>
            <p className="signature">Yvinna Patrícia</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sobre;
